export default __webpack_public_path__ + "static/media/step2.44c39a31.svg";